import {Fzf} from 'fzf'

export const exactMatch = (searchText, items) => {
    const re = new RegExp(RegExp.escape(searchText), 'ig')

    return items
        .map(([key, text]) => {
            const indexes = []
            let match

            while (null !== match) {
                match = re.exec(text)

                if (match) {
                    const {index} = match
                    indexes.push([index, index + searchText.length])
                }
            }

            if (0 < indexes.length) {
                return [key, text, indexes]
            }
            else {
                return null
            }
        })
        .filter(a => a)
}

export const fuzzyMatch = (searchText, items) => {
    const selector = ([, text]) => text
    const fzf = new Fzf(items, {selector})
    const entries = fzf.find(searchText)

    return entries.map(({item, positions}) => {
        const indexes = [...positions].sort().map(i => [i, i + 1])
        return [...item, indexes]
    })
}
